export default __webpack_public_path__ + "static/media/logo morade.f4bf4360.png";